import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../../utils/firebase';
import { logEvent } from 'firebase/analytics';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const isProd =
      import.meta.env.VITE_VERCEL_TARGET_ENV === 'production' ||
      import.meta.env.MODE === 'production';

    if (analytics) {
      const eventParams: Record<string, any> = {
        page_location: window.location.href,
        page_path: location.pathname,
      };

      if (!isProd) {
        eventParams['debug_mode'] = true;
      }

      logEvent(analytics, 'page_view', eventParams);
    }
  }, [location]);

  return null;
};

const PageTracker = () => {
  usePageTracking();
  return null;
};

export { PageTracker };
